import { useEffect, useState } from 'react';
import { api } from '../lib/api';

/**
 * Die Rückkehr von Twitch.
 *
 * Eine kurze Zwischenseite: Sie sagt, was herausgekommen ist, und führt zurück in die Lobby. Wohin
 * zurück, wird **hier** ermittelt und nicht aus der Adresse übernommen – eine Weiterleitung, die
 * einem Ziel aus der Anfrage folgt, wäre ein bequemer Weg, fremde Seiten glaubwürdig zu machen.
 */
export function TwitchFertig({ status, kanal }: { status: string; kanal: string | null }) {
  const [ziel, setZiel] = useState<string | null>(null);

  useEffect(() => {
    void api
      .lobbies()
      .then((liste) => setZiel(liste[0]?.id ?? null))
      .catch(() => setZiel(null));
  }, []);

  const gut = status === 'ok';
  const text = gut
    ? `Der Kanal ${kanal ?? ''} ist verbunden.`
    : status === 'abgebrochen'
      ? 'Die Verbindung wurde abgebrochen. Es hat sich nichts geändert.'
      : status === 'BAD_STATE'
        ? 'Dieser Anmeldeweg ist abgelaufen. Versuch es noch einmal.'
        : 'Die Verbindung zu Twitch hat nicht geklappt.';

  return (
    <main className="page narrow">
      <h1>Twitch</h1>
      <p className={gut ? 'muted' : 'notice'}>{text}</p>
      <button
        type="button"
        className="primary"
        onClick={() =>
          window.location.assign(
            ziel ? `/lobby/${ziel}?twitch=${encodeURIComponent(status)}${kanal ? `&kanal=${encodeURIComponent(kanal)}` : ''}` : '/',
          )
        }
      >
        Zurück zur Lobby
      </button>
    </main>
  );
}
